// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-icon{background-color:rgba(26,26,26,.2);border-radius:50px;cursor:pointer;display:inline-block}.user-icon.user-letter{background-color:#1a1a1a;border:4px solid #8ad2e9}.user-letter{font-weight:300;line-height:1.4;text-align:center;-webkit-user-select:none;user-select:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
